<template >
	<div :style="{width: width+'%'}">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'SWidget',

	data(){
		return{}
	},

	components: {},

	props: {
		width: {required: true, type: Number},
	},

	mounted(){}
}
</script>

<style scoped>

</style>